module.exports = __webpack_public_path__ + "static/2910-logo-3097ceb5f0be0547216cb3cfa2e2dfd3.png";